export enum Preview {
  DEFAULT = "DEFAULT",
  HEXAGON = "HEXAGON",
}
